import { render } from "./PetugasCs.vue?vue&type=template&id=0f495152"
import script from "./PetugasCs.vue?vue&type=script&lang=js"
export * from "./PetugasCs.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__